import React from 'react';
import './CopPlatform.page.css';

const CopPlatform = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="copplatform-container">
            <div className="copplatform-header">COP Platform</div>
            <div className="copplatform-footer">© {currentYear} CPC Index</div>
        </div>
    );
};

export default CopPlatform;